import React, { useState, useEffect } from 'react';
import { OfferRideFlow } from '@/components/OfferRideFlow';
import { AppStoreButtons } from '@/components/landing/AppStoreButtons';


const Index = () => {
  // Keep offer ride flow functionality for future use
  const [showOfferRideFlow, setShowOfferRideFlow] = useState(false);

  const handleCloseOfferRide = () => {
    setShowOfferRideFlow(false);
  };

  // Listen for offer ride events from header
  useEffect(() => {
    const handleShowOfferRide = () => {
      setShowOfferRideFlow(true);
    };

    window.addEventListener('showOfferRideFlow', handleShowOfferRide);
    return () => window.removeEventListener('showOfferRideFlow', handleShowOfferRide);
  }, []);

  if (showOfferRideFlow) {
    return <OfferRideFlow onBack={handleCloseOfferRide} />;
  }

  return (
    <div className="min-h-screen bg-background-cream font-roboto">
      <main>
        <AppStoreButtons />
      </main>
    </div>
  );
};

export default Index;
